export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';

import { post, get } from 'utils/fetchRequest';

export const login = async (dispatch, data) => {
    try {
        const result = await post('auth', data);

        if (result.code === 200) {
            dispatch({ type: LOGIN_SUCCESS, data: result.data });
        } else {
            dispatch({ type: LOGIN_ERROR });
        }

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const logout = (dispatch) => {
    dispatch({ type: LOGOUT });
};

export const changePassword = async (data) => {
    try {
        return await post('auth/changepassword', data);
    } catch (err) {
        return { error: err };
    }
};

export const setUser = (dispatch, user) => {
    // localStorage-ээс уншсан user-ийг redux-д тавих (AppInitializer-аас)
    dispatch({ type: SET_USER, data: user });
};

export const refreshUser = async (dispatch) => {
    try {
        const result = await get('auth/me');
        if (result.code === 200) {
            dispatch({ type: SET_USER, data: result.data });
        }
        return result;
    } catch (err) {
        return { error: err };
    }
};
